module.exports = __webpack_public_path__ + "static/assets/b276c5f099603d0f559549f876ca2658.png";